import loadable from '@loadable/component';

export const ProductSlider = loadable(() => import('./LoadableProductSlider'), {
  ssr: false,
});
